const ProductTours = {
    MONTHLY_BOOKKEEPING: 'monthly_bookkeeping',
} as const;

export { ProductTours };
export type ProductTourKey = keyof typeof ProductTours;
export type ProductTourValue = (typeof ProductTours)[ProductTourKey];
